import moment from 'moment'

import callAny from './call_any'
import mediaSearchSync from 'sync/media_search_sync'

function iso8601toMilliseconds(value) {
	return moment.duration(value, moment.ISO_8601).asMilliseconds()
}

function *getYoutubeVideosDetails(ids) {
	const response = yield callAny(mediaSearchSync.getYoutubeVideosDetails, ids)

	return response.payload.videos.data.map(video => ({
		...video,
		duration: iso8601toMilliseconds(video.duration),
	}))
}

export {
	getYoutubeVideosDetails,
}
